import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Image, Row } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import i18n from 'I18n';

import BaseMultipleSelectorV2 from 'components/base/BaseMultipleSelectorV2';
import { SectionTopTitle } from 'components/base/CommonComponent';
import { ReactHookFormMarkDown } from 'components/base/CustomMarkDownArea';
import CustomRadios from 'components/base/CustomRadios';
import {
  ReactHookFormErrorMessage,
  hasError,
} from 'components/base/ErrorFieldMessage';
import InputFieldControl from 'components/base/InputFieldControl';
import BasePrompt from 'components/base/prompt/BasePrompt';
import BrandSelectDropdown from 'components/campaign/campaignCreation/BrandSelectDropdown';
import TargetCustomerSection from 'components/customerGroup/TargetCustomerSection';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import ReactHookFormSwitch from 'components/reactHookFormComponents/ReactHookFormSwitch';
import ReactHookFormTitleWithRadio from 'components/reactHookFormComponents/ReactHookFormTitleWithRadio';
import {
  COUPON_MODES,
  COUPON_REDEMPTION_METHOD,
  COUPON_SET_MEDIUM,
  COUPON_SET_TYPES,
  COUPON_TYPES,
  CustomerSelectionBehavior,
  LanguageConfig,
  STORE_LOADING_TYPE,
} from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';

import { createAction } from 'utils';

import './CouponGeneral.scss';

const CREATE_NEW_TYPE = {
  brand: 'brand',
  store: 'store',
  none: 'none',
};

const CustomCouponStockSelectionOptions = [
  {
    label:
      'Single coupon stock - Customers do not need to select a store before using the coupon.',
    tips: 'The coupon amount will be shared among the selected applicable stores.',
    value: false,
  },
  {
    label:
      'Individual stock per applicable store - Customers must select a store before using the coupon.',
    tips: 'The coupon amount will be assigned to each applicable store individually. If only one store is selected, customers do not need to select a store before using the coupon.',
    value: true,
  },
];

const CustomerStoreSelectionOptions = [
  {
    label: 'Either select store when acquire or before use in wallet',
    value: CustomerSelectionBehavior.NO_LIMIT,
  },
  {
    label: 'Select store when acquire',
    value: CustomerSelectionBehavior.SELECT_WHEN_ACQUIRE,
  },
  {
    label: 'Select store before use (select in wallet)',
    value: CustomerSelectionBehavior.SELECT_IN_WALLET,
  },
];

const CustomerOnlineOfflineSelectionOptions = [
  {
    label:
      'Either select online or physical store when acquiring or before use in wallet',
    value: CustomerSelectionBehavior.NO_LIMIT,
  },
  {
    label: 'Select online or physical store when acquiring',
    value: CustomerSelectionBehavior.SELECT_WHEN_ACQUIRE,
  },
  {
    label: 'Select online or physical store before use (select in wallet)',
    value: CustomerSelectionBehavior.SELECT_IN_WALLET,
  },
];

const mapPropsToState = (state) => ({});

const CouponStoreBehavious = ({ language, onFocus = () => {} }) => {
  const [refreshDate, setRefreshDate] = useState(new Date());
  const [createNewType, setCreateNewType] = useState(CREATE_NEW_TYPE.none);

  const [testRadio, setTestRadio] = useState(false);

  const dispatch = useDispatch();
  const params = useParams();

  const createNewText =
    createNewType === CREATE_NEW_TYPE.brand ? 'brand' : 'store';
  const { watch, setValue, control, formState, clearErrors } = useFormContext();
  const { errors } = formState;

  const typeField = 'type';
  const watchType = watch(typeField);
  const watchMediumType = watch('mediumType');

  const shouldBeUsedInStoresFieldName = 'shouldBeUsedInStores';
  const watchshouldBeUsedInStores = watch(shouldBeUsedInStoresFieldName);
  const customerStoreSelectionBehaviorFieldName =
    'customerStoreSelectionBehavior';
  const watchCustomerStoreSelectionBehavior = watch(
    customerStoreSelectionBehaviorFieldName,
  );
  const customerOnlineOfflineSelectionBehaviorFieldName =
    'customerOnlineOfflineSelectionBehavior';
  const watchCustomerOnlineOfflineSelectionBehavior = watch(
    customerOnlineOfflineSelectionBehaviorFieldName,
  );

  const CouponTypeStoreSelectorSection = (
    <>
      {language === LanguageConfig.english ? (
        // <ReactHookFormSwitch
        //   title={i18n.t('using_in_specific_store', { locale: language })}
        //   tips={i18n.t('using_in_specific_store_tips', { locale: language })}
        //   valueFieldName={shouldBeUsedInStoresFieldName}
        //   extraActionOnChange={({ value }) => {
        //     if (!value) {
        //       setValue('selectedStores', null, {
        //         shouldDirty: true,
        //       });
        //     }
        //   }}
        //   disabled={watchCouponModeFieldName === COUPON_MODES.STORE_SPECIAL}
        // />
        <ReactHookFormTitleWithRadio
          title={'Select coupon stock type'}
          valueFieldName={shouldBeUsedInStoresFieldName}
          defaultValue={watchshouldBeUsedInStores}
          options={CustomCouponStockSelectionOptions}
          optionsClassName="coupon-stock-options"
          disabled={false}
        />
      ) : (
        <>
          <CustomTitleLabel
            title={i18n.t('using_in_specific_store', { locale: language })}
          />
          <div className="tips-with-popover">
            <label className="tips-message">
              {i18n.t('using_in_specific_store_tips', { locale: language })}
            </label>
          </div>
          <div className="second-section-content">
            {i18n.t(watchshouldBeUsedInStores ? 'yes' : 'no', {
              locale: language,
            })}
          </div>
        </>
      )}
    </>
  );

  const StoreSection = () => (
    <div
      // hidden={watchSelectedBrand?.pk ? false : true}
      onFocus={() => onFocus('selectedStores')}
    >
      {watchType === COUPON_TYPES.NORMAL && CouponTypeStoreSelectorSection}
    </div>
  );

  const selectionBehaviorView = () => {
    console.log('@@184: ', watchshouldBeUsedInStores);
    if (watchType === COUPON_TYPES.NORMAL && watchshouldBeUsedInStores) {
      if (language === LanguageConfig.english) {
        return (
          <div>
            <ReactHookFormTitleWithRadio
              title={'Store selection behavior on front end (For coupon campaign)'}
              valueFieldName={customerStoreSelectionBehaviorFieldName}
              options={CustomerStoreSelectionOptions}
              disabled={false}
              tips={"If this coupon set will link to an earning rule, by default “Select store before use” will be applied."}
            />
            <ReactHookFormErrorMessage
              errors={errors}
              id={customerStoreSelectionBehaviorFieldName}
            />
          </div>
        );
      }
    }
    if (
      watchType === COUPON_TYPES.NORMAL &&
      !watchshouldBeUsedInStores &&
      watchMediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE
      //      && (
      //        watchOfflineCouponSetType === COUPON_SET_TYPES.SYSTEM_GENERATED ||
      //        watchOfflineRedemptionMethod !== COUPON_REDEMPTION_METHOD.POS_UPDATED_CODE
      //      )
    ) {
      if (language === LanguageConfig.english) {
        return (
          <div>
            <ReactHookFormTitleWithRadio
              title={'Online or physical store selection on front end'}
              tips={
                'Since this coupon medium is "online or offline",  even if this coupon are not required to select applicable store (toggle off), the customer still need to select "online" or "offline".'
              }
              valueFieldName={customerOnlineOfflineSelectionBehaviorFieldName}
              options={CustomerOnlineOfflineSelectionOptions}
              disabled={false}
            />
            <ReactHookFormErrorMessage
              errors={errors}
              id={customerOnlineOfflineSelectionBehaviorFieldName}
            />
          </div>
        );
      }
    }
    return null;
  };

  return (
    <>
      <SectionTopTitle title={'Coupon stock'} />

      <StoreSection />

      {selectionBehaviorView()}
    </>
  );
};

export default connect(mapPropsToState)(CouponStoreBehavious);
